module.exports = __webpack_public_path__ + "assets/img/chirp-messages.256f9271.svg";